"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initialValues = exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _cccisdFormik = require("cccisd-formik");
var _cccisdLaravelAppdefs = require("cccisd-laravel-appdefs");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var initialValues = exports.initialValues = {
  show: true,
  title: 'Fidelity Adherence',
  description: 'Average per session breakdown',
  chart: {
    targetLineValue: '80',
    verticalScaleMin: '0',
    verticalScaleMax: '100',
    scoreSuffix: '%',
    showLegend: true,
    showLabels: true,
    colorScheme: 'default'
  }
};
var colorSchemeOptions = [{
  value: 'default',
  label: 'Default'
}, {
  value: 'highlightAboveBenchmark',
  label: 'Highlight Above Benchmark'
}];
var Component = function Component(props) {
  return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
    name: "show",
    component: _cccisdFormik.CccisdToggle,
    label: "Show Fidelity Adherence Chart?"
  }), /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
    name: "title",
    component: _cccisdFormik.CccisdInput,
    label: "Title"
  }), /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
    name: "description",
    component: _cccisdFormik.CccisdInput,
    label: "Description"
  }), /*#__PURE__*/_react["default"].createElement("h4", null, "Chart Settings"), /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
    name: "chart.showLegend",
    component: _cccisdFormik.CccisdToggle,
    label: "Show Legend?"
  }), /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
    name: "chart.showLabels",
    component: _cccisdFormik.CccisdToggle,
    label: "Show Labels?"
  }), /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
    name: "chart.colorScheme"
  }, function (_ref) {
    var field = _ref.field,
      form = _ref.form;
    return /*#__PURE__*/_react["default"].createElement(_cccisdFormik.CccisdFieldWrapper, {
      field: field,
      form: form,
      label: "Color Scheme"
    }, /*#__PURE__*/_react["default"].createElement("div", null, colorSchemeOptions.map(function (option) {
      return /*#__PURE__*/_react["default"].createElement("button", {
        key: option.value,
        type: "button",
        className: 'btn btn-default ' + (option.value === field.value ? 'active' : ''),
        onClick: function onClick() {
          form.setFieldValue('chart.colorScheme', option.value);
        }
      }, option.label);
    })));
  }), /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
    name: "chart.targetLineValue",
    component: _cccisdFormik.CccisdInput,
    label: "Benchmark Value",
    type: "number"
  }), /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
    name: "chart.verticalScaleMin",
    component: _cccisdFormik.CccisdInput,
    label: "Y-axis Min Value",
    type: "number"
  }), /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
    name: "chart.verticalScaleMax",
    component: _cccisdFormik.CccisdInput,
    label: "Y-axis Max Value",
    type: "number"
  }), /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
    name: "chart.scoreSuffix",
    component: _cccisdFormik.CccisdInput,
    label: "Y-axis Suffix"
  }));
};
var _default = exports["default"] = (0, _cccisdLaravelAppdefs.widgetBuilder)({
  initialValues: initialValues
})(Component);